module.exports = __webpack_public_path__ + "img/footer_icons.5654ad71.png";